import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import type { InstallBannerState } from '@alltrails/install-prompt/slices/installBanner';
import type { UpsellContentState } from '../slices/upsellContent';

export type RootState = {
  installBanner?: InstallBannerState;
  upsellContent?: UpsellContentState;
};

export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();

export const useAppStore = () => useStore<RootState>();

export const useAppSelector: TypedUseSelectorHook<RootState> = (selector: (state: RootState) => any) =>
  useSelector<RootState, any>(selector, shallowEqual);
